/* 
  This file reunites all the variables related to the oamount of usable storage
  and the performance level variables, selected by users on the application.
*/

/* 
  The data structure correspond to an object of objects, 
  it's props are associated with the props of selectedOption application's state.
*/

interface calculatorVariablesTypes {
  [index: number]: {
    [index: string]: {
      compDrivesNumber: number;
      ibmDrivesNumber: number;
      compRackUnits: number;
      ibmRackUnits: number;
      compCarbonOutputVariable: number;
      ibmCarbonOutputVariable: number;
      totalSavingsVariable: number;
      savedTreesNumber: number;
      compDriveInterface: string;
      ibmdriveInterface: string;
    };
  };
}

const calculatorVariables: calculatorVariablesTypes = {
  50: {
    lite: {
      compDrivesNumber: 9,
      ibmDrivesNumber: 6,
      compRackUnits: 3,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 21,
      ibmCarbonOutputVariable: 5.327,
      totalSavingsVariable: 12256.32,
      savedTreesNumber: 142.2,
      compDriveInterface: 'Flash',
      ibmdriveInterface: 'Flash-SFF',
    },
    medium: {
      compDrivesNumber: 9,
      ibmDrivesNumber: 6,
      compRackUnits: 3,
      ibmRackUnits: 1,
      compCarbonOutputVariable: 31,
      ibmCarbonOutputVariable: 10.583,
      totalSavingsVariable: 15764.11,
      savedTreesNumber: 183.2,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    high: {
      compDrivesNumber: 11,
      ibmDrivesNumber: 6,
      compRackUnits: 4,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 52,
      ibmCarbonOutputVariable: 13.517,
      totalSavingsVariable: 30818.84,
      savedTreesNumber: 357.8,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    extreme: {
      compDrivesNumber: 9,
      ibmDrivesNumber: 6,
      compRackUnits: 10,
      ibmRackUnits: 4,
      compCarbonOutputVariable: 83,
      ibmCarbonOutputVariable: 32.622,
      totalSavingsVariable: 39749.24,
      savedTreesNumber: 461.4,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
  },
  100: {
    lite: {
      compDrivesNumber: 11,
      ibmDrivesNumber: 6,
      compRackUnits: 3,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 22,
      ibmCarbonOutputVariable: 5.327,
      totalSavingsVariable: 13033.32,
      savedTreesNumber: 151.2,
      compDriveInterface: 'Flash',
      ibmdriveInterface: 'Flash-SFF',
    },
    medium: {
      compDrivesNumber: 12,
      ibmDrivesNumber: 6,
      compRackUnits: 4,
      ibmRackUnits: 1,
      compCarbonOutputVariable: 33,
      ibmCarbonOutputVariable: 10.708,
      totalSavingsVariable: 15764.11,
      savedTreesNumber: 207,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    high: {
      compDrivesNumber: 11,
      ibmDrivesNumber: 6,
      compRackUnits: 4,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 53,
      ibmCarbonOutputVariable: 13.606,
      totalSavingsVariable: 31368.99,
      savedTreesNumber: 364,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    extreme: {
      compDrivesNumber: 10,
      ibmDrivesNumber: 6,
      compRackUnits: 10,
      ibmRackUnits: 4,
      compCarbonOutputVariable: 83,
      ibmCarbonOutputVariable: 32.712,
      totalSavingsVariable: 40060.4,
      savedTreesNumber: 465.6,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
  },
  250: {
    lite: {
      compDrivesNumber: 21,
      ibmDrivesNumber: 13,
      compRackUnits: 4,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 28,
      ibmCarbonOutputVariable: 6.473,
      totalSavingsVariable: 16928.32,
      savedTreesNumber: 196.4,
      compDriveInterface: 'Flash',
      ibmdriveInterface: 'Flash-SFF',
    },
    medium: {
      compDrivesNumber: 21,
      ibmDrivesNumber: 12,
      compRackUnits: 4,
      ibmRackUnits: 1,
      compCarbonOutputVariable: 38,
      ibmCarbonOutputVariable: 13.975,
      totalSavingsVariable: 19268.04,
      savedTreesNumber: 223.4,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    high: {
      compDrivesNumber: 21,
      ibmDrivesNumber: 11,
      compRackUnits: 5,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 73,
      ibmCarbonOutputVariable: 16.314,
      totalSavingsVariable: 45414.73,
      savedTreesNumber: 527.6,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    extreme: {
      compDrivesNumber: 20,
      ibmDrivesNumber: 11,
      compRackUnits: 11,
      ibmRackUnits: 4,
      compCarbonOutputVariable: 90,
      ibmCarbonOutputVariable: 35.42,
      totalSavingsVariable: 43739.13,
      savedTreesNumber: 507.4,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
  },
  500: {
    lite: {
      compDrivesNumber: 37,
      ibmDrivesNumber: 24,
      compRackUnits: 6,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 41,
      ibmCarbonOutputVariable: 8.274,
      totalSavingsVariable: 25961.47,
      savedTreesNumber: 301.6,
      compDriveInterface: 'Flash',
      ibmdriveInterface: 'Flash-SFF',
    },
    medium: {
      compDrivesNumber: 39,
      ibmDrivesNumber: 24,
      compRackUnits: 7,
      ibmRackUnits: 3,
      compCarbonOutputVariable: 63,
      ibmCarbonOutputVariable: 19.213,
      totalSavingsVariable: 34759.2,
      savedTreesNumber: 403.6,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    high: {
      compDrivesNumber: 39,
      ibmDrivesNumber: 19,
      compRackUnits: 6,
      ibmRackUnits: 2,
      compCarbonOutputVariable: 74,
      ibmCarbonOutputVariable: 20.647,
      totalSavingsVariable: 42615.9,
      savedTreesNumber: 495.2,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    extreme: {
      compDrivesNumber: 35,
      ibmDrivesNumber: 19,
      compRackUnits: 12,
      ibmRackUnits: 4,
      compCarbonOutputVariable: 101,
      ibmCarbonOutputVariable: 39.753,
      totalSavingsVariable: 49022.31,
      savedTreesNumber: 568.8,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
  },
  1000: {
    medium: {
      compDrivesNumber: 76,
      ibmDrivesNumber: 37,
      compRackUnits: 12,
      ibmRackUnits: 5,
      compCarbonOutputVariable: 120,
      ibmCarbonOutputVariable: 24.778,
      totalSavingsVariable: 76507.93,
      savedTreesNumber: 887.6,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    high: {
      compDrivesNumber: 76,
      ibmDrivesNumber: 37,
      compRackUnits: 10,
      ibmRackUnits: 4,
      compCarbonOutputVariable: 134,
      ibmCarbonOutputVariable: 45.085,
      totalSavingsVariable: 71287.83,
      savedTreesNumber: 827.2,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
    extreme: {
      compDrivesNumber: 68,
      ibmDrivesNumber: 37,
      compRackUnits: 15,
      ibmRackUnits: 4,
      compCarbonOutputVariable: 140,
      ibmCarbonOutputVariable: 49.502,
      totalSavingsVariable: 72346.96,
      savedTreesNumber: 839.8,
      compDriveInterface: 'NVMe',
      ibmdriveInterface: 'NVMe',
    },
  },
};
export default calculatorVariables;
